import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';
import { recordFields } from '../records';

// One day's record and the medications it can take an entry for, together,
// because every step of the daily record needs both: the medication step
// lists the medications, and the others show what is already saved. The
// medications are the current list, whatever the day (#144), plus any
// archived since that are still on that day's list or have an entry that
// day, so an entry already written can always be corrected. Entries stay on
// their own day, and completeness counts only the medications on the list
// that day. Both are undefined while loading or when the read failed; error
// and retry are useLoad's.
//
// reload is what a step calls after saving, so the next step opens on what
// the service now holds rather than on what the previous step thought it sent.
export function useRecord(date) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Record($date: String!) {
        dailyRecord(date: $date) { ${ recordFields } }
        recordMedications(date: $date) { id name doseMg archived }
      }`,
      variables: { date }
    });
  }, [ graphql, date ]);

  const { data, error, retry, reload } = useLoad(read);

  return useMemo(function() {
    if (data == null) {
      return { error, retry, reload };
    }

    return { record: data.dailyRecord, medications: data.recordMedications, error, retry, reload };
  }, [ data, error, retry, reload ]);
}
